import { fetchSameOrigin } from '../Utils';

const requestAVisit = (memberId, groupId = undefined) => {
  const body = JSON.stringify({
    deep_link_path: "/consult/new",
    active_benefit_id: groupId,
  });

  return fetchSameOrigin(`/members/${memberId}/impersonate`, 'POST', { body })
    .then(r => r.json())
    .then(response => {
      window.open(response.impersonation_url);
      return true;
    });
};

export default requestAVisit;
